import { render } from "./Enablements.vue?vue&type=template&id=2e1ba808"
import script from "./Enablements.vue?vue&type=script&lang=js"
export * from "./Enablements.vue?vue&type=script&lang=js"

import "./Enablements.vue?vue&type=style&index=0&id=2e1ba808&lang=less"

import exportComponent from "/codebuild/output/src3271881597/src/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__